import LoggerFactory from 'utilities/loggerv2/loggerFactory';
import ErrorCodes from 'utilities/loggerv2/errorCodes';

const logger = LoggerFactory.getLogger('FSP-api-logger');

const handleFSPError = async (error: unknown): Promise<void> => {
  const errorObj = error instanceof Error ? error : new Error(String(error || 'Unknown error'));

  if (!Object.prototype.hasOwnProperty.call(errorObj, 'code')) {
    Object.defineProperty(errorObj, 'code', {
      value: 'UNKNOWN_ERROR',
      writable: true,
      enumerable: true,
    });
  }

  const resolvedLogger = await logger;

  if (resolvedLogger?.logWithCode) {
    const errorCode = ErrorCodes.FSP_API_REQUEST_ERROR;

    if (errorCode?.code) {
      resolvedLogger.logWithCode(errorCode, errorObj);
    } else {
      resolvedLogger.error('FSP API request error (fallback)', errorObj, {
        errorCategory: 'FSP',
        errorCode: 'FSP_API_REQUEST_ERROR',
      });
    }
  } else {
    console.error('Logger not available for FSP error:', errorObj);
  }
};

export default handleFSPError;
